<template>
  <div class="pagination" v-if="totalPages > 1">
    <div class="pagination-info">
      <span class="info-text">
        Mostrando {{ startItem }}-{{ endItem }} di {{ totalItems }}
      </span>
    </div>
    <div class="pagination-controls">
      <button
        class="pagination-button"
        @click="goToPage(currentPage - 1)"
        :disabled="currentPage === 1"
        aria-label="Pagina precedente"
      >
        ←
      </button>

      <button
        v-for="page in visiblePages"
        :key="page"
        class="pagination-button page-number"
        :class="{ active: page === currentPage }"
        @click="goToPage(page)"
      >
        {{ page }}
      </button>

      <button
        class="pagination-button"
        @click="goToPage(currentPage + 1)"
        :disabled="currentPage === totalPages"
        aria-label="Pagina successiva"
      >
        →
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaginationPage',
  props: {
    currentPage: {
      type: Number,
      required: true,
      default: 1,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      default: 15,
    },
  },
  computed: {
    startItem() {
      return (this.currentPage - 1) * this.itemsPerPage + 1;
    },
    endItem() {
      const end = this.currentPage * this.itemsPerPage;
      return Math.min(end, this.totalItems);
    },
    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      // Adjust start if we're near the end
      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.$emit('page-change', page);
      }
    },
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem 0;
  width: 100%;
}

.pagination-info {
  text-align: center;
}

.info-text {
  font-size: 0.875rem;
  color: #6b7280;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.pagination-button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  padding: 0.5rem;
  border: 2px solid #2e4eed;
  background: white;
  color: #2e4eed;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pagination-button:hover:not(:disabled) {
  background: #2e4eed;
  color: white;
}

.pagination-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  border-color: #d1d5db;
  color: #9ca3af;
}

.pagination-button.active {
  background: #2e4eed;
  color: white;
}

.page-number {
  min-width: 40px;
}

@media (max-width: 768px) {
  .pagination-controls {
    gap: 0.25rem;
  }

  .pagination-button {
    min-width: 36px;
    height: 36px;
    font-size: 0.875rem;
  }

  .page-number {
    min-width: 36px;
  }
}

@media (max-width: 480px) {
  .pagination-button {
    min-width: 32px;
    height: 32px;
    font-size: 0.8rem;
    padding: 0.375rem;
  }

  .page-number {
    min-width: 32px;
  }

  .info-text {
    font-size: 0.75rem;
  }
}
</style>
